import { render, staticRenderFns } from "./DiasFestivos.vue?vue&type=template&id=1ec87f08&scoped=true"
import script from "./DiasFestivos.vue?vue&type=script&lang=js"
export * from "./DiasFestivos.vue?vue&type=script&lang=js"
import style0 from "./DiasFestivos.vue?vue&type=style&index=0&id=1ec87f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec87f08",
  null
  
)

export default component.exports